import Tag from "components/Tag";
import useLabels from "hooks/useLabels";

/**
 * @component FullTextAnalysisComingSoonTooltip
 * @description Tooltip for the Full Text Analysis tab showing it's coming soon
 */
const FullTextAnalysisComingSoonTooltip = () => {
  const [labels] = useLabels("features.full-text-analysis");
  return (
    <div
      className="flex flex-col gap-2 text-fg-base"
      data-testid="tooltip-full-text-analysis"
    >
      <div className="flex items-center gap-2 mt-1 justify-between">
        <div className="flex items-center gap-2">
          <i className="icon-lock text-lg" />
          <p className="sm-bold">{labels.title}</p>
        </div>
        <Tag label={labels["coming-soon"]} size="sm" className="decor" />
      </div>
      <p className="sm-normal">{labels.description}</p>
    </div>
  );
};

export default FullTextAnalysisComingSoonTooltip;
